<template>
  <div class="search-bar__date">
    <div
      v-if="dateFilterAlternative"
      class="alternative"
      :class="{ 'cleaned-datepicker': clearnedDatepicker }"
    >
      <v-date-picker
        ref="popover"
        v-model="dateSelectedRoot"
        :popover-direction="calendarDirection"
        :date-picker-show-caps="false"
        :date-picker-show-day-popover="false"
        :pane-width="290"
        :tint-color="'#7f1a54'"
        :max-date="maxDate"
        :min-date="limitData"
        mode="range"
        title
        maxlength="23"
        name="dateFilter"
        show-caps
        expanded
        @drag="onDragDate"
        @dayclick="onDateClick"
        @input="onDateChange"
      >
        <md-input-container
          id="datePickerSelect"
          slot-scope="{ inputValue, updateValue }"
        >
          <md-input
            id="dateFilter"
            ref="dateFilter"
            :readonly="false"
            type="text"
            :value="inputValue"
            expanded
            @change.native="updateValue($event.target.value)"
          />
          <div
            v-if="!clearnedDatepicker && clearButton"
            class="clear-button"
            @click.stop="clearDates()"
          >
            <em class="clear-button__icon" />
          </div>
          <md-icon :md-src="'/static/images/icon-calendar-alternative.svg'">date_range</md-icon>
        </md-input-container>
      </v-date-picker>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';

export default {
  name: 'DatePickerRange',
  props: {
    dateSelected: {
      type: Object,
      default: () => ({
        start: null,
        end: null,
      }),
    },
    dateFilterAlternative: {
      type: Boolean,
      default: false,
    },
    calendarDirection: {
      type: String,
      default: 'bottom',
    },
    clearButton: {
      type: Boolean,
      default: true,
    },
    maxDate: {
      type: Date,
      default: () => new Date(),
    },
    limitData: Date,
    defaultStartDate: [String, Date],
    defaultEndDate: [String, Date],
  },
  data: () => ({
    clearnedDatepicker: false,
    dateSelectedRoot: {
      start: null,
      end: null,
    },
  }),
  watch: {
    dateSelected: {
      immediate: true,
      handler(newVal) {
        if (
          newVal?.start &&
          newVal?.end &&
          (!this.dateSelectedRoot.start ||
            !this.dateSelectedRoot.end ||
            this.dateSelectedRoot.start.getTime() !== new Date(newVal.start).getTime() ||
            this.dateSelectedRoot.end.getTime() !== new Date(newVal.end).getTime())
        ) {
          this.dateSelectedRoot = {
            start: new Date(newVal.start),
            end: new Date(newVal.end),
          };
          this.clearnedDatepicker = false;
          this.updateCustomLabel();
        }
      },
    },
  },
  watch: {
    dateSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dateSelectedRoot = newVal;
        this.$emit('update:dateSelected', newVal);
      }
    },
    startDateSelected(newVal) {
      this.updateCustomLabel();
    },
    endDateSelected(newVal) {
      this.updateCustomLabel();
    },
    dateSelectedRoot(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dateSelectedRoot = newVal;
        this.$emit('update:dateSelected', newVal);
      }
    },
  },
  mounted() {
    if (this.dateSelected?.start && this.dateSelected?.end) {
      this.dateSelectedRoot = {
        start: new Date(this.dateSelected.start),
        end: new Date(this.dateSelected.end),
      };
      this.clearnedDatepicker = false;
      this.updateCustomLabel();
    } else if (this.defaultStartDate && this.defaultEndDate) {
      this.dateSelectedRoot.start = Moment(this.defaultStartDate, 'DD/MM/YYYY').toDate();
      this.dateSelectedRoot.end = Moment(this.defaultEndDate, 'DD/MM/YYYY').toDate();
      this.clearnedDatepicker = false;
      this.updateCustomLabel();
    } else {
      this.clearnedDatepicker = true;
    }
  },
  updated() {
    this.updateCustomLabel();
  },
  methods: {
    clearDates() {
      this.$refs.dateFilter.setParentPlaceholder();
      this.$refs.popover.hidePopover();
      this.clearnedDatepicker = true;
      this.dateSelectedRoot = {};
      this.$emit('update:dateSelected', {
        start: null,
        end: null,
      });
    },
    onDateClick(newVal) {
      this.$emit('handleSelectFirstDate', newVal.date);
    },
    onDragDate() {
      setTimeout(() => {
        this.clearnedDatepicker = false;
      }, 30);
    },
    onDateChange(value) {
      this.dateSelectedRoot = value;
      this.clearnedDatepicker = false;

      this.$emit('update:dateSelected', {
        start: value.start,
        end: value.end,
      });

      this.updateCustomLabel();
    },
    updateCustomLabel() {
      this.$nextTick(() => {
        let today = Moment(new Date()).format('DD/MM/YYYY');
        let startDateFormated = Moment(this.dateSelectedRoot.start).format('DD/MM/YYYY');
        let endDateFormated = Moment(this.dateSelectedRoot.end).format('DD/MM/YYYY');

        if (startDateFormated === today && endDateFormated === today) {
          this.$refs.dateFilter.$el.value = 'Hoje';
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.clear-button {
  margin: auto;

  em {
    padding: 3px 4px 1px 4px;
    font-size: 11px;
    border-radius: 5px;
    margin-left: 0px;
    position: relative;
    margin: auto;
    cursor: pointer;

    &:hover {
      background: $brand-primary;
      color: white;
    }
  }
}

.clear-button__icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all 0.2s ease;
  border-radius: 5px;

  &::after {
    content: '\D7';
    color: #266d4d;
    font-size: 14px;
  }

  &:hover::after {
    color: white;
  }
}

.cleaned-datepicker {
  .c-day-content-wrapper {
    background: #fafafa;
  }

  .c-day-content {
    color: #393d46 !important;
  }

  .days-nights {
    display: none;
  }
}

.days-nights {
  width: 100px !important;
}

.alternative {
  .md-input-container {
    margin-top: 0;
    min-height: 50px;

    &::after {
      display: none !important;
    }
  }
}

.search-bar {
  &__date {
    margin: 0 10px;
    flex: 2;
    position: relative;

    input {
      cursor: pointer;
    }

    &__button {
      &:not([disabled]) {
        &:not(.md-raised) {
          height: 33px;
          min-height: 33px;
          width: calc(100% - 32px);
          margin: 0;
          padding: 0;
          font-size: 15px;
          color: #717171;
          font-weight: 400;
          text-align: left;
          text-transform: lowercase;
          background: transparent;
          margin-top: -1px;

          @supports (-ms-ime-align: auto) {
            color: #222222 !important;
          }

          &:hover,
          &:active {
            &:not([disabled]):not(.md-raised) {
              background: none;
            }
          }

          .md-ink-ripple {
            display: none;
          }
        }
      }
    }

    &__icon {
      cursor: pointer;
      position: absolute;
      top: 23px;
      right: 0;
    }

    .md-input-container {
      label {
        opacity: 1;
        top: 22px;
        font-size: 15px;
        color: #717171;

        @supports (-ms-ime-align: auto) {
          color: #222222 !important;
        }
      }

      &.md-input-focused {
        label {
          opacity: 1;
          font-size: 15px;
          color: #717171 !important;

          @supports (-ms-ime-align: auto) {
            color: #222222 !important;
          }
        }
      }

      &.md-has-value {
        label {
          top: 0;
          font-size: 12px;
          color: #858585 !important;
        }

        .md-input {
          font-size: 15px;
          letter-spacing: -0.2px;
          color: #717171;

          @supports (-ms-ime-align: auto) {
            color: #222222 !important;
          }
        }
      }

      &.md-input-invalid {
        label {
          color: #717171 !important;

          @supports (-ms-ime-align: auto) {
            color: #222222 !important;
          }
        }

        &.md-has-value {
          label {
            color: #858585 !important;
          }
        }
      }
    }
  }
}
</style>
